import React from 'react';
import { holdSummary } from '../../../logic/withdrawalRequest';

// The condensed topbar's form of WithdrawalHoldBanner: short, since the patient's name is the row's only shrinkable element.
/** @param {{ requestedOn?: string | null, chartsLive?: boolean, onOpen?: () => void }} props */
export default function WithdrawalHoldChip({ requestedOn = null, chartsLive = false, onOpen }) {
  const hint = `Withdrawal requested${requestedOn ? ` on ${requestedOn}` : ''}. ${holdSummary(chartsLive)}`;
  return (
    <button type="button" className="withdrawal-hold-chip wi-tip" data-tip={hint} aria-label={`On hold: ${hint} Open the withdrawal request.`} onClick={onOpen}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
        <line x1="9" y1="5" x2="9" y2="19" />
        <line x1="15" y1="5" x2="15" y2="19" />
      </svg>
      On hold
    </button>
  );
}
